import { createContext } from 'react';

export const ContextAPI = createContext()